import { useState } from "react";
import { Funnel, Check } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "./ui/command";

const triggerCls = (active) =>
  `group inline-flex items-center gap-1.5 uppercase tracking-[0.2em] text-[10px] font-bold transition-colors ${active ? "text-ps-blue" : "text-slate-600 hover:text-ps-blue"}`;

const Trigger = ({ label, active, testid }) => (
  <button type="button" className={triggerCls(active)} data-testid={`${testid}-trigger`}>
    {label}
    <Funnel size={11} weight={active ? "fill" : "bold"} className={active ? "" : "opacity-40 group-hover:opacity-100"} />
  </button>
);

export const HeaderFilter = ({ label, value, options, onChange, testid }) => {
  const [open, setOpen] = useState(false);
  const pick = (v) => { onChange(v); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><span><Trigger label={label} active={!!value} testid={testid} /></span></PopoverTrigger>
      <PopoverContent className="p-0 w-60 normal-case tracking-normal" align="start">
        <Command>
          <CommandInput placeholder={`Search ${label.toLowerCase()}…`} data-testid={`${testid}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>No match.</CommandEmpty>
            <CommandItem value="__all__" onSelect={() => pick("")} data-testid={`${testid}-option-all`} className="text-xs font-semibold">
              <Check size={12} className={`mr-2 ${!value ? "opacity-100 text-ps-blue" : "opacity-0"}`} /> All
            </CommandItem>
            {options.map((o) => (
              <CommandItem key={o.value} value={o.label} onSelect={() => pick(o.value)} data-testid={`${testid}-option-${o.value}`} className="text-xs font-mono-data">
                <Check size={12} className={`mr-2 ${o.value === value ? "opacity-100 text-ps-blue" : "opacity-0"}`} /> {o.label}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export const HeaderDateFilter = ({ from, to, onChange, testid }) => {
  const inputCls = "w-full h-8 px-2 border border-slate-300 rounded text-xs font-mono-data focus:border-ps-blue outline-none";
  return (
    <Popover>
      <PopoverTrigger asChild><span><Trigger label="Date" active={!!(from || to)} testid={testid} /></span></PopoverTrigger>
      <PopoverContent className="w-60 p-3 space-y-2 normal-case tracking-normal" align="start">
        <label className="block text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">From
          <input type="date" value={from} max={to || undefined} onChange={(e) => onChange({ date_from: e.target.value })} data-testid={`${testid}-from`} className={inputCls} />
        </label>
        <label className="block text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">To
          <input type="date" value={to} min={from || undefined} onChange={(e) => onChange({ date_to: e.target.value })} data-testid={`${testid}-to`} className={inputCls} />
        </label>
        {(from || to) && (
          <button type="button" onClick={() => onChange({ date_from: "", date_to: "" })} data-testid={`${testid}-clear`} className="text-[11px] text-ps-red hover:underline">Clear dates</button>
        )}
      </PopoverContent>
    </Popover>
  );
};
